const CategoryTabHeader = ({categories, active, setCategory}) => {

  return (
    <div className="tabs__heading wrap">
      <ul className="tabs__heading__list">
        {categories.map((item, key) => (
          <li
            key={key}
            className={`tabs__heading__item tabs__heading__item--main${item.value === active.value ? " active" : ""}`}
            onClick={() => setCategory(item)}
            >
            {item.label}
          </li>
        ))}
      </ul>
      <div className="tabs__heading_underline" />
    </div>
  )
}

export default CategoryTabHeader
